import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl-next';
import { IconCardLayout } from 'view/layout/icon-card-layout';
import Lozenge from '@atlaskit/lozenge';
import { token } from '@atlaskit/tokens';
import { AutoScaledImage } from '@atlassian/help-center-common-component/auto-scaled-image';
import i18n from './messages';

export interface Props {
    icon: React.ReactNode;
    name: string;
    email?: string;
    isNew?: boolean;
}

const UserPickerItem: React.FunctionComponent<Props> = ({ icon, name, email, isNew }) => {
    const content = email ? `${name} (${email})` : name;
    const iconComponent = typeof icon === 'string' ? <AutoScaledImage src={icon} alt="" /> : icon;

    return (
        <>
            <UserPickerItemSection>
                <IconCardLayout leftIcon={iconComponent} content={content} iconSize={16} iconMargin={8} padding={0} />
            </UserPickerItemSection>
            {isNew && (
                <UserPickerItemSection marginLeft={token('space.200', '16px')}>
                    <Lozenge appearance="new">
                        <FormattedMessage {...i18n.newUserLozengeText} />
                    </Lozenge>
                </UserPickerItemSection>
            )}
        </>
    );
};

export default UserPickerItem;

interface UserPickerItemSectionProps {
    marginLeft?: string;
}

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const UserPickerItemSection = styled.div`
    display: inline-block;
    margin-left: ${(props: UserPickerItemSectionProps) => `${props && props.marginLeft ? props.marginLeft : '0px'}`};
    vertical-align: top;
    grid-area: 1 / 1 / 2 / 3;
`;
